import React from 'react';
import { GivelifyLabel } from '@givelify/givelify-ui';
import { styled, TableCell, TableRow, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Table = styled('div')(({ theme }) => ({
    '& .header': {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    }
}));

export const LeftColumn = styled(Grid)(({ theme }) => ({
    paddingLeft: theme.spacing(4),
}));

export const Middle = styled(Grid)(({
    textAlign: 'right',
}));

export const RightColumn = styled(Grid)(({ theme }) => ({
    textAlign: 'right',
    paddingRight: theme.spacing(4),
}));

const commonRowStyles = ({ theme }) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderBottom: '1px solid #ccc',
    background: '#ffffff',
    '&:hover': {
      background: '#F6F6F6',
    },
    color: theme.legacy.colors.primaryDarkGray,
  });

export const GridRow = styled(Grid)(commonRowStyles);

export const StyledTableRow = styled(TableRow)(commonRowStyles);

export const TextEllipsis = styled(TableCell)(({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));

export const FirstColumn = styled(TableCell)(({ theme }) => ({
    paddingLeft: theme.spacing(5),
}));

export const LastColumn = styled(TableCell)(({ theme }) => ({
    paddingRight: theme.spacing(5),
}));

const DonationsRowTable: React.FCC = () => {
    const { t } = useTranslation();
    const copy = {
        date: t('bankDeposits.headers.date'),
        amount: t('bankDeposits.headers.amount'),
        status: t('bankDeposits.headers.status'),
    };
    return (
        <Table>
            <Grid container className="header" justifyContent="space-between">
                <LeftColumn
                    item
                    lg={4}
                    md={4}
                    sm={4}
                    xl={4}
                    xs={4}
                >
                    <GivelifyLabel bold text={copy.date} variant="heading5" />
                </LeftColumn>
                <Middle
                    item
                    lg={4}
                    md={4}
                    sm={4}
                    xl={4}
                    xs={4}
                >
                    <GivelifyLabel bold text={copy.amount} variant="heading5" />
                </Middle>
                <RightColumn
                    item
                    lg={4}
                    md={4}
                    sm={4}
                    xl={4}
                    xs={4}
                >
                    <GivelifyLabel bold text={copy.status} variant="heading5" />
                </RightColumn>
            </Grid>
        </Table>
    );
};

export default React.memo(DonationsRowTable);
